import React, { useEffect, useState } from 'react';
import { getAllSetting } from 'service/base';
import { SETTING_KEYS } from 'utils/common/const';
import { SITE } from 'config/config';
import { twMerge } from 'tailwind-merge';
import Header from 'components/Header/Header';
import RightGif from 'components/RightGif';

const RulePage = () => {
  const [dataSettings, setDataSettings] = useState([]);

  useEffect(() => {
    fetchAllSetting();
  }, []);

  const fetchAllSetting = async () => {
    try {
      const res = await getAllSetting({ site: SITE });
      setDataSettings(res?.data || []);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-screen fixed top-0 left-0 object-cover block"
        style={{ zIndex: 0 }}
      />
      {/* <div className="fixed bottom-0 left-0 w-auto max-w-[min(40vw,280px)] 2xl:max-w-[320px] hidden xl:block leading-none pointer-events-none z-[1]">
        <img
          src="/lv_left.png"
          alt=""
          className="block w-full h-full object-contain object-left-bottom"
        />
      </div>
      <div className="fixed bottom-0 right-0 w-auto max-w-[min(50vw,420px)] 2xl:max-w-[500px] hidden xl:block leading-none pointer-events-none z-[1]">
        <img
          src="/lv_right.png"
          alt=""
          className="block w-full h-full object-contain object-right-bottom"
        />
      </div> */}
      <RightGif />
      <div className="container relative z-10">
        <Header />
        <div className="mx-auto -mt-6 w-[95%] lg:w-full max-w-[1200px]">
          <div
            className="rule-html-content"
            dangerouslySetInnerHTML={{
              __html: dataSettings?.find((item) => item.key === SETTING_KEYS.RULE)?.content
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default RulePage;
